import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft, FiCheck, FiSend, FiAlertCircle, FiMessageCircle } from 'react-icons/fi';
import { toast } from '../Toast';
import { SettingsHeader } from './ClientSettings';
import { PLANS, CURRENT_PLAN, Plan } from './clientSettingsData';

// Billing › Request a Plan Change: every plan with what it includes; picking one asks the account manager to switch.
// UI only: nothing is sent to the account manager yet
const ChangePlan: React.FC = () => {
    const history = useHistory();
    const [picked, setPicked] = useState<Plan | null>(null);
    const [note, setNote] = useState('');

    const send = () => {
        toast.info('Preview only: this isn’t connected yet, so no request was sent');
        history.push('/client-settings/billing');
    };

    return <div className="change-plan">
        <button type="button" className="link back" onClick={() => history.push('/client-settings/billing')}><FiArrowLeft /> Back to billing</button>
        <SettingsHeader title="Change Plan" sub="Compare the plans and ask your Investi account manager to switch. The current plan runs to 1 September 2027." />

        <div className="plans">
            {PLANS.map(p => {
                const current = p.id === CURRENT_PLAN;
                return <section key={p.id} className={`card plan${current ? ' current' : ''}${picked?.id === p.id ? ' picked' : ''}`}>
                    <div className="plan-head">
                        <h2>{p.name}</h2>
                        {current && <span className="badge ok">Current plan</span>}
                    </div>
                    <p className="summary">{p.summary}</p>
                    <div className="plan-price">
                        {p.price ? <><strong>{p.price}</strong><span>per year + GST</span></> : <><strong>Custom</strong><span>priced for your company</span></>}
                    </div>
                    {p.includes && <div className="includes">Everything in {p.includes}, plus:</div>}
                    <ul className="included">
                        {p.features.map(f => <li key={f}><FiCheck /> {f}</li>)}
                    </ul>
                    {current
                        ? <button type="button" className="btn-outline" disabled>Your current plan</button>
                        : <button type="button" className={picked?.id === p.id ? 'btn-primary' : 'btn-outline'} onClick={() => setPicked(p)}>
                            {picked?.id === p.id ? <><FiCheck /> Selected</> : p.price ? `Switch to ${p.name}` : 'Talk to Us'}
                        </button>}
                </section>;
            })}
        </div>

        {picked && <section className="card request">
            <div className="section-title">
                <span className="icon-tile"><FiMessageCircle /></span>
                <div className="text">
                    <h2>Request {picked.name}</h2>
                    <div className="hint">Your Investi account manager replies the same business day</div>
                </div>
            </div>
            <label className="field">
                <span className="label">Anything we should know? <em>(optional)</em></span>
                <textarea rows={3} value={note} onChange={e => setNote(e.target.value)} />
            </label>
            <div className="modal-note warn"><FiAlertCircle /> Nothing changes until you confirm by email. Goes to your account manager and accounts@investi.com.au.</div>
            <div className="buttons">
                <button type="button" className="btn-outline" onClick={() => setPicked(null)}>Cancel</button>
                <button type="button" className="btn-primary" onClick={send}><FiSend /> Send Request</button>
            </div>
        </section>}
    </div>;
};

export default ChangePlan;
